<main @fade>
  <nb-card status="primary">
    <div class="columns">
      <div class="column">
        <div class="all-table">
          <ngx-table
                     [configuration]="configuration"
                     [data]="cartProductList"
                     #table
                     [columns]="columns">
          </ngx-table>
        </div>
      </div>
    </div>
    <ng-template #checkboxTpl let-rowIndex="rowIndex">
      <nb-checkbox
        type="checkbox"
        [checked]="selected.has(rowIndex)"
        (checkedChange)="toggle(rowIndex)"
      />
    </ng-template>
    <ng-template #codeIconTpl let-row data-th="Код">
      <div class="responsive-table product-list__table-code" data-th="Код">
        <div class="code-table">
          <div class="code-table__title">
            <p><span class="mouse-pointer">{{ row.productCode || "-" }}</span></p>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #photoTpl let-row data-th="Фото">
      <div class="responsive-table product-list__photo" data-th="Фото">
        <div class="photo-table">
          <div class="photo-table__picture" *ngIf="row.syncUid">
            <a class="mouse-pointer">
              <img alt="" [src]="getImageUri(row.picture)">
            </a>
          </div>

          <div class="photo-table__picture" *ngIf="!row.syncUid">
            <a class="mouse-pointer">
              <img [src]="getImageUri(row.picture)" alt="">
            </a>
          </div>

        </div>
      </div>
    </ng-template>

    <ng-template #headerTpl let-row let-rowIndex="rowIndex">
      <div class="responsive-table" data-th="Наименование">
        <div class="name-table">
          <div class="name-table__title">
            <p *ngIf="row.syncUid"><span class="mouse-pointer" (click)="openModalProduct(row.syncUid)">{{ row.header }}</span></p>
            <p *ngIf="!row.syncUid"><span class="mouse-pointer">{{ row.header }}</span></p>
          </div>

          <div class="alert alert-warning" style="cursor: pointer" *ngIf="!row.syncUid">
            Нет точных совпадений. <a href="#" (click)="openSearchProduct(rowIndex); $event.preventDefault()">Подберите&nbsp;замену в каталоге</a>
          </div>

          <div class="alert alert-warning" style="cursor: pointer" *ngIf="null !== row.similarProductList && row.similarProductList.length > 0">
            Неcколько совпадений. <a href="#" (click)="openSimilarProducts(rowIndex, row.similarProductList, row.importKey); $event.preventDefault()">Выберите другой вариант</a>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #availabilityTpl let-row>
      <app-product-availability [product]="row"/>
    </ng-template>

    <ng-template #priceTpl let-row>
      <app-product-price [product]="row" [hideCurrency]="true"/>
    </ng-template>

      <ng-template #priceVATTpl let-row>
          <app-product-price [product]="row" [showVAT]="true" [hideCurrency]="true"/>
      </ng-template>

    <ng-template #cartTpl let-row>
      <app-specification-add-to-cart [cartProduct]="row"/>
    </ng-template>

  </nb-card>
</main>


